module.exports = __webpack_public_path__ + "img/caja-piura.7ad218d5.svg";